import { useContext } from 'react'
import { MdAdd } from 'react-icons/md'

import Skeleton from '../../../components/Skeleton'
import { LabelLarge, LabelMedium } from '../../../components/typography/Label'
import { CheckoutCartContext } from '../../../contexts/CheckoutCartContext'
import { LanguageContext } from '../../../contexts/LanguageContext'
import { UserContext } from '../../../contexts/UserContext'

function generateMenuCategoryColor(str) {
  // adapted from https://codepen.io/sergiopedercini/pen/RLJYLj
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 6) - hash)
  }
  let h = hash % 375
  return `hsl(${h}, 100%, 45%)`
}

function MenuItem({ item, itemsIsLoading }) {
  const { user } = useContext(UserContext)
  const { language } = useContext(LanguageContext)
  const { setCheckoutCartItems } = useContext(CheckoutCartContext)

  function handleClick() {
    setCheckoutCartItems((prev) => [...prev, item])
  }

  if (itemsIsLoading) {
    return (
      <button
        className="menu-item"
        style={{
          borderLeft:
            !user || itemsIsLoading ? 'none' : '10px solid var(--white)',
        }}
      >
        {!user && <div className="menu-item-image"></div>}
        <div className="menu-item-container">
          <div>
            <LabelLarge style={{ marginBottom: '6px' }}>
              <Skeleton width="150px" height="22px" />
            </LabelLarge>
            {!user && (
              <LabelMedium style={{ fontWeight: 500 }}>
                <Skeleton width="100%" height="16px" />
                <Skeleton width="150px" height="16px" />
              </LabelMedium>
            )}
            <LabelMedium>
              <Skeleton width="50px" height="16px" />
            </LabelMedium>
          </div>
          <div style={{ marginLeft: 'auto' }}>
            <MdAdd className="menu-item-icon" />
          </div>
        </div>
      </button>
    )
  }

  return (
    <button
      className="menu-item"
      style={{
        borderLeft: !user ? 'none' : `10px solid`,
        borderColor: !user ? 'white' : generateMenuCategoryColor(item.category),
      }}
      onClick={() => handleClick()}
    >
      {item?.image_url && !user && (
        <div
          className="menu-item-image"
          role="img"
          alt={item.name}
          style={{
            backgroundImage: `url(${item?.image_url})`,
          }}
        />
      )}
      <div className="menu-item-container">
        <div>
          <LabelLarge
            style={{ marginBottom: '6px', textTransform: 'capitalize' }}
          >
            {item.name}
          </LabelLarge>
          {!user && (
            <LabelMedium style={{ marginBottom: '10px' }}>
              {item?.description}
            </LabelMedium>
          )}
          <LabelMedium style={{ fontWeight: 500 }}>
            ${item?.price.toFixed(2)} {language.code !== 'en' && ' USD'}
          </LabelMedium>
        </div>

        <div style={{ marginLeft: 'auto' }}>
          <MdAdd className="menu-item-icon" />
        </div>
      </div>
    </button>
  )
}

export default MenuItem
